"use client";

import type { ReactNode } from "react";

import { useStorefrontProductAvailability } from "@/hooks/useProduct";
import type { Locales } from "@/lib/i18n";

type StorefrontRouteGuardProps = {
  children: ReactNode;
  locale: Locales;
  slug: string;
};

const StorefrontRouteGuard = ({ children, locale, slug }: StorefrontRouteGuardProps) => {
  const { data: isAvailable, isPending, isError } = useStorefrontProductAvailability(locale, slug);

  if (isPending || isError || !isAvailable) return null;

  return children;
};

export default StorefrontRouteGuard;
